import React from 'react';

import LookupsHelper from 'lib/LookupsHelper';
import { I18n as I } from 'react-redux-i18n';

import { Descriptions, Row, Col } from 'antd';

import {
  PhoneOutlined,
  MobileOutlined,
  PrinterOutlined,
  MailOutlined,
} from '@ant-design/icons';

const descriptionDetailsStyle = {
  fontSize: 16,
  fontWeight: 600,
};

const iconStyle = {
  marginLeft: 8,
  marginTop: 3,
};

const spanIconStyle = {
  display: 'flex',
  alignContent: 'center',
  // justifyContent: 'center',
};

const imageStyle = {
  marginRight: 10,
  height: '32px',
  width: '32px',
  textAlign: 'center',
};

const OperatorExpertDetails = ({
  countries,
  party,
  regions,
  taxOffices,
  user,
}) => {
  return (
    <div>
      <Row gutter={[10, 10]}>
        <Col className="profile">
          <Descriptions
            colon={false}
            column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
            size="small"
            bordered
          >
            <Descriptions.Item label="Username">
              <span style={descriptionDetailsStyle}>
                {party && party.Email}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col className="profile">
          <Descriptions
            className="profile"
            colon={false}
            column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
            size="small"
            bordered
          >
            <Descriptions.Item label={I.t('FIRSTNAME')}>
              <span style={descriptionDetailsStyle}>
                {party && party.FirstName}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('SURNAME')}>
              <span style={descriptionDetailsStyle}>
                {party && party.SurName}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('TAXNUMBER')}>
              <span style={descriptionDetailsStyle}>{party && party.AFM}</span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('TAXOFFICE')}>
              <span style={descriptionDetailsStyle}>
                {party &&
                  LookupsHelper.getDescription(taxOffices, party.TaxOfficeID)}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col className="profile">
          <Descriptions
            className="profile"
            colon={false}
            column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
            size="small"
            bordered
          >
            <Descriptions.Item
              label={
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>{I.t('PHONE')}</span>
                  <span style={spanIconStyle}>
                    <PhoneOutlined style={iconStyle} />
                  </span>
                </div>
              }
            >
              <span style={descriptionDetailsStyle}>
                {party && party.Phone}
              </span>
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>{I.t('FAX')}</span>
                  <span style={spanIconStyle}>
                    <PrinterOutlined style={iconStyle} />
                  </span>
                </div>
              }
            >
              <span style={descriptionDetailsStyle}>{party && party.Fax}</span>
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>{I.t('MOBILE')}</span>
                  <span style={spanIconStyle}>
                    <MobileOutlined style={iconStyle} />
                  </span>
                </div>
              }
            >
              <span style={descriptionDetailsStyle}>
                {party && party.Mobile}
              </span>
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>{I.t('EMAIL')}</span>
                  <span style={spanIconStyle}>
                    <MailOutlined style={iconStyle} />
                  </span>
                </div>
              }
            >
              <span style={descriptionDetailsStyle}>
                {party && party.Email}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col className="profile">
          <Descriptions
            className="profile"
            colon={false}
            column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
            size="small"
            bordered
          >
            <Descriptions.Item label={I.t('CITY')}>
              <span style={descriptionDetailsStyle}>{party && party.City}</span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('STREET')}>
              <span style={descriptionDetailsStyle}>
                {party && party.Street}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('NUMBER')}>
              <span style={descriptionDetailsStyle}>
                {party && party.StreetNumber}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('POSTALCODE')}>
              <span style={descriptionDetailsStyle}>
                {party && party.PostalCode}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col className="profile">
          <Descriptions
            className="profile"
            colon={false}
            column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
            size="small"
            bordered
          >
            <Descriptions.Item label={I.t('REGION')}>
              <span style={descriptionDetailsStyle}>
                {party && LookupsHelper.getDescription(regions, party.RegionID)}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label={I.t('COUNTRY')}>
              <span style={descriptionDetailsStyle}>
                {party &&
                  LookupsHelper.getDescription(countries, party.CountryID)}
              </span>
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </div>
  );
};

export default OperatorExpertDetails;
